/**
 * Errors functionality
 */
export default ({
  errorHandling
}) => {
  return {
    mixins: [
      errorHandling
    ],
    data: () => ({
      /**
       * @vuese
       * Store server errors in a array
       */
      serverErrors: []
    }),
    computed: {
      /**
       * @vuese
       * Return the message of the first error if present
       */
      serverErrorMsg() {
        return this.serverErrors[0] && this.serverErrors[0].message
      }
    },
    methods: {
      /**
       * @vuese
       * Clear all errors
       */
      clearErrors() {
        this.serverErrors = []
      },
      /**
       * @vuese
       * Main error functions, is called any time an error is thrown
       */
      handleErrors(error) {
        if (error === 'busy') {
          return
        } else if (error.type === 'validation') {
          this.trackValidationError(error.errors)
        } else {
          this.errorHandlingAction(error)
          this.trackServerError()
        }
      }
    }
  }
}